import { useMemo } from 'react'

import { useTable } from '@/ui/Table'
import { Log } from '@/types/logs'

import { useGetUnfinishedLogs } from '../../api/useGetUnfinishedLogs'
import { reorderLinkedLogs } from '../../helpers/reorderLinkedLogs'
import { useUnfinishedLogsColumns } from './useUnfinishedLogsColumns'

export const useUnfinishedLogsTable = (actionCallback?: (log: Log) => void) => {
    const { data, isLoading: isDataLoading } = useGetUnfinishedLogs()

    const logs = useMemo(() => {
        if (!data) {
            return []
        }

        return reorderLinkedLogs(data.unfinishedLogs)
    }, [data])

    const columns = useUnfinishedLogsColumns(isDataLoading, actionCallback)

    const table = useTable({
        data: logs,
        columns,
    })

    return {
        table,
        hasNoRows: !logs.length,
        columns,
        isLoading: isDataLoading,
    }
}
